import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@material-ui/core";
import { Button } from '@coolremote/shared';
import { t } from "ttag";
import useStyles from "../AlertInfo.style";
import useTypes from "@hooks/useTypes";

interface SnoozeDialogProps {
  open: boolean;
  onClose: () => void;
  snoozeError: string;
  snoozeDuration: string;
  setSnoozeDuration: (val: string) => void;
  snoozeScope: string;
  setSnoozeScope: (val: string) => void;
  handleSnooze: () => void;
  alert: any;
}

const SnoozeDialog: React.FC<SnoozeDialogProps> = ({
  open,
  onClose,
  snoozeError,
  snoozeDuration,
  setSnoozeDuration,
  snoozeScope,
  setSnoozeScope,
  handleSnooze,
  alert
}) => {
  const classes: any = useStyles({});
  const { snoozeDurations } = useTypes();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <div className={classes.dialogTitle}>
        <DialogTitle>{t`Snooze Alert`}</DialogTitle>
      </div>
      <DialogContent className={classes.emailDialogContent} style={{ overflow: 'visible' }}>
        {snoozeError && <Typography color="error" style={{ marginBottom: 10 }}>{snoozeError}</Typography>}
        <FormControl variant="outlined" fullWidth style={{ marginBottom: 20, marginTop: 10 }}>
          <InputLabel>{t`Duration`}</InputLabel>
          <Select
            value={snoozeDuration}
            onChange={(e) => setSnoozeDuration(e.target.value as string)}
            label={t`Duration`}
          >
            {snoozeDurations.map((d: any) => (
              <MenuItem key={d.value} value={d.value}>
                {d.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="outlined" fullWidth style={{ marginBottom: 10 }}>
          <InputLabel>{t`Scope`}</InputLabel>
          <Select
            value={snoozeScope}
            onChange={(e) => setSnoozeScope(e.target.value as string)}
            label={t`Scope`}
          >
            <MenuItem value="unit">{t`Unit:`} {alert?.unitName}</MenuItem>
            <MenuItem value="system" disabled={!alert?.systemId}>{t`System:`} {alert?.systemName}</MenuItem>
          </Select>
        </FormControl>
        <div className={classes.emailDialogActions}>
          <Button white width={110} marginRight onClick={onClose}>
            {t`Cancel`}
          </Button>
          <Button onClick={handleSnooze} width={110}>
            {t`Snooze`}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SnoozeDialog;
